import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  Box,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  ConversionCycletimeChart,
  PipelineAgingChart,
  POCConversionChart,
  QualificationConversionChart,
} from "../DealConversionCharts";

const DealConversionPaper = ({
  classes,
  paperTitle,
  dealConversionData,
  isDealConversionLoading,
  company,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            {/* Deal Conversion Efficiency */}
            {dealConversionData?.title}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        {isDealConversionLoading ? (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton
                variant="rect"
                animation="wave"
                height={280}
                width="100%"
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {/* Chart 1: Pipeline Aging */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <PipelineAgingChart
                      data={dealConversionData?.pipelineAging}
                      ageBuckets={dealConversionData?.ageBuckets}
                      company={company}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            {/* Chart 2: Conversion Cycletime */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <ConversionCycletimeChart
                      data={dealConversionData?.conversionCycletime}
                      timeBuckets={dealConversionData?.timeBuckets}
                      company={company}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            {/* Chart 3: Percent Conversion from Qualification */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <QualificationConversionChart
                      data={dealConversionData?.qualificationConversion}
                      target={dealConversionData?.qualificationTarget}
                      company={company}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            {/* Chart 4: Percent Conversion from POC */}
            <Grid item xs={12} md={6}>
              <Card className={classes.chartCard}>
                <CardContent>
                  <div className={classes.chartContainer}>
                    <POCConversionChart
                      data={dealConversionData?.pocConversion}
                      target={dealConversionData?.pocTarget}
                      company={company}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Paper>
    </Grid>
  );
};

export default DealConversionPaper;
